import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'

import {
  dealStatusCreate,
  dealStatusCreateFailure,
  dealStatusUpdate,
  dealStatusUpdateFailure,
  dealStatusDelete,
  dealStatusDeleteFailure
} from '../actions'

import {
  DEAL_STATUS_CREATE_SUBMIT,
  DEAL_STATUS_UPDATE_SUBMIT,
  DEAL_STATUS_DELETE_SUBMIT
} from '../constants'

export function * dealStatusCreateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      'api/v3/admin/deal_statuses',
      {
        method: 'POST',
        body: JSON.stringify({
          deal_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(dealStatusCreate(response))
  } catch (exception) {
    console.error(exception.message)
    yield put(dealStatusCreateFailure(exception.message))
  }
}

export function * watchDealStatusCreateSaga () {
  yield call(takeEvery, DEAL_STATUS_CREATE_SUBMIT, dealStatusCreateSaga)
}

export function * dealStatusUpdateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      `api/v3/admin/deal_statuses/${payload.id}`,
      {
        method: 'PUT',
        body: JSON.stringify({
          deal_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(dealStatusUpdate(response))
  } catch (exception) {
    yield put(dealStatusUpdateFailure(exception.message))
  }
}

export function * watchDealStatusUpdateSaga () {
  yield call(takeEvery, DEAL_STATUS_UPDATE_SUBMIT, dealStatusUpdateSaga)
}

export function * dealStatusDeleteSaga ({ payload }) {
  try {
    yield call(
      fetcher,
      `api/v3/admin/deal_statuses/${payload.id}`,
      {
        method: 'DELETE',
        body: JSON.stringify({})
      }
    )
    yield put(dealStatusDelete(payload))
  } catch (exception) {
    yield put(dealStatusDeleteFailure(exception.message))
  }
}

export function * watchDealStatusDeleteSaga () {
  yield call(takeEvery, DEAL_STATUS_DELETE_SUBMIT, dealStatusDeleteSaga)
}
